import { ValidatorChainBuilder } from "helpers/validator";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { ITargetsData, ITargetsDataError, FinancialTargetFilter } from "components/product-collection/footer/types";
import {
    NoDuplicateRowsRule,
    NotEmptyRule,
    RequiredColumnsRule,
    OnlyExistingDoorsRule,
    OnlyExistingDeliveriesRule,
} from "./validation-rules";

export const DOORS_COLUMN = "door";
export const ID_COLUMN = "__id__";

const requiredColumns = [DOORS_COLUMN];

type GetTargetsValidatorProps = {
    deliveries: IAllocationDimension;
    doors: IAllocationDimension;
    filters: FinancialTargetFilter[];
};

const getTargetsValidator = ({ deliveries, doors, filters }: GetTargetsValidatorProps) => {
    // TODO: add rule to validate that the filters are valid
    return new ValidatorChainBuilder<ITargetsData[], ITargetsDataError>()
        .add(new NotEmptyRule())
        .add(new OnlyExistingDeliveriesRule(ID_COLUMN, DOORS_COLUMN, deliveries, filters))
        .add(new OnlyExistingDoorsRule(DOORS_COLUMN, doors))
        .add(new RequiredColumnsRule(requiredColumns))
        .add(new NoDuplicateRowsRule(ID_COLUMN))
        .getFirst();
};

type ValidateTargetsDataProps = {
    data: ITargetsData[];
    deliveries: IAllocationDimension;
    doors: IAllocationDimension;
    filters: FinancialTargetFilter[];
};

export const validateTargetsData = ({
    data,
    deliveries,
    doors,
    filters,
}: ValidateTargetsDataProps): ITargetsDataError => {
    const targetsValidator = getTargetsValidator({ deliveries, doors, filters });
    return targetsValidator.validate(data, {});
};
